<template>
  <fragment>
    <Title title="机构性质统计"></Title>
    <Nav :dataArray="components" :callBack="callBack"></Nav>
    <div class="layout-view withoutTitleAndNav">
      <component :is="currentComponent"></component>
    </div>
  </fragment>
</template>

<script>
import Title from "@/components/common/Title.vue";
import Nav from "@/components/common/Nav.vue";
import LayoutBase from "@/views/mixin/LayoutBase.vue";

import WelfareCentreNatureElderResidentsBedNumber from "@/components/org/WelfareCentreNatureElderResidentsBedNumber.vue";
import WelfareCentreNatureEmployeesNumber from "@/components/org/WelfareCentreNatureEmployeesNumber.vue";
export default {
  components: {
    Title,
    Nav,
    WelfareCentreNatureElderResidentsBedNumber,
    WelfareCentreNatureEmployeesNumber,
  },
  mixins: [LayoutBase],
  data() {
    return {
      components: [
        {
          key: "WelfareCentreNatureElderResidentsBedNumber",
          title: "养老服务机构数量",
        },
        {
          key: "WelfareCentreNatureEmployeesNumber",
          title: "本地户籍长者数量",
        },
      ],
    };
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="less" scoped></style>
